import { Route, Switch } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import AsyncLoader from 'unsubscribe-ui/components/core/loader';
import { lazy } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmationPage = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/Confirmation')),
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "CONFIRMATION_PRE_LOAD"
  })
});
const Preferences = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/ManagePreferences')),
  // TODO: Update pre-load marker after debugging
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "MANAGE_PREFERENCES_PRE_LOAD"
  })
});
const UnsubscribeAll = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/UnsubscribeAll')),
  // TODO: Update pre-load marker after debugging
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "UNSUBSCRIBE_ALL_PRE_LOAD"
  })
});
const UnsubscribeSingle = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/UnsubscribeSingle')),
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "UNSUBSCRIBE_SINGLE_PRE_LOAD"
  })
});
const Backup = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/Backup')),
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "BACKUP_PRE_LOAD"
  })
});
const ContactVerify = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/ContactVerify')),
  loading: /*#__PURE__*/_jsx(NavMarker, {
    name: "CONTACT_VERIFY_PRE_LOAD"
  })
});
const DOIConfirmation = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/DOIConfirmation'))
});
const ConfirmationPreview = AsyncLoader({
  Component: /*#__PURE__*/lazy(() => import('./containers/ConfirmationPreview'))
});
export default function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language/manage",
      exact: true,
      component: Preferences
    }), /*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language/unsubscribe",
      exact: true,
      component: UnsubscribeAll
    }), /*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language/single",
      exact: true,
      component: UnsubscribeSingle
    }), /*#__PURE__*/_jsx(Route, {
      path: "/:language/doi/confirmation",
      exact: true,
      component: DOIConfirmation
    }), /*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language/:route/confirmation",
      exact: true,
      component: ConfirmationPage
    }), /*#__PURE__*/_jsx(Route, {
      path: "/:language/:route/confirmation/preview",
      exact: true,
      component: ConfirmationPreview
    }), /*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language/contact/:route",
      exact: true,
      component: ContactVerify
    }), /*#__PURE__*/_jsx(Route, {
      path: "/(hs/email-subscriptions/preferences/)?:language?/backup",
      exact: true,
      component: Backup
    }), /*#__PURE__*/_jsx(Route, {
      path: "/",
      component: Backup
    })]
  });
}